// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from 'semantic-ui-react';

import {MediaBrowserPanelProps} from '../Component';
import {TilePagination} from '../tiles';

type PaginationProps = {
  tilePagination: TilePagination;
  panelViewerRef: React.MutableRefObject<HTMLDivElement | null>;
  updateConfig: MediaBrowserPanelProps['updateConfig'];
};

const PaginationComp = ({
  tilePagination: {start, size, total},
  panelViewerRef,
  updateConfig,
}: PaginationProps) => {
  const nextDisabled: boolean = start + size >= total;
  const prevDisabled: boolean = start <= 0;

  const pageStart = start + 1;
  const pageEnd = Math.min(start + size, total);

  return (
    <div style={{marginBottom: -5}} className="inline-pagination">
      <div className="pagination-count text-sm">
        {pageStart} - {pageEnd} of {total}
      </div>
      <Button.Group className="pagination-buttons">
        <Button
          size="tiny"
          disabled={prevDisabled}
          className="wb-icon-button only-icon page-down-button"
          onClick={() => {
            updateConfig({
              page: {start: Math.max(0, start - size)},
            });
          }}>
          <LegacyWBIcon name="previous" />
        </Button>
        <Button
          size="tiny"
          disabled={nextDisabled}
          className="wb-icon-button only-icon page-down-button"
          onClick={() => {
            const maxOffset = Math.floor(total / size) * size;
            updateConfig({
              page: {start: Math.min(start + size, maxOffset)},
            });
            if (panelViewerRef.current) {
              panelViewerRef.current.scrollTop = 0;
            }
          }}>
          <LegacyWBIcon name="next" />
        </Button>
      </Button.Group>
    </div>
  );
};
export const Pagination: React.FC<PaginationProps> = React.memo(PaginationComp);
